import {FC, ReactNode} from "react";
import Table from "../../ui/Table";
import {ILog} from "../../../types/ApiTypes";
import {nl2br} from "../../../helpers/humanSpaceState";
import {BsCheckCircle, BsExclamationCircle, BsExclamationTriangle, BsInfoCircle} from "react-icons/bs";

interface Props {
    logs: ILog[];
}

const LogsList: FC<Props> = (props) => {
    const getIcon = (status: string): ReactNode => {
        const iconClass = 'text-xl mr-2'
        if (status === "warning") {
            return <BsExclamationTriangle className={`${iconClass} text-orange-500`}/>
        } else if (status === "error") {
            return <BsExclamationCircle className={`${iconClass} text-error-brighter`}/>
        } else if (status === "info") {
            return <BsInfoCircle className={iconClass}/>
        } else {
            return <BsCheckCircle className={`${iconClass} text-success-darker`}/>
        }
    }

    return (
        <Table.Skeleton>
            <Table.THead>
                <Table.HeadTR>
                    <Table.TH>Status</Table.TH>
                    <Table.TH>Nachricht</Table.TH>
                    <Table.TH>Datum</Table.TH>
                </Table.HeadTR>
            </Table.THead>
            <Table.TBody>
                {props.logs.length > 0 ? (
                    props.logs.map(x => (
                        <Table.BodyTR key={x.id}>
                            <Table.TD>{getIcon(x.status)}</Table.TD>
                            <Table.TD>
                                <span className='text-sm'>{nl2br(x.description)}</span>
                            </Table.TD>
                            <Table.TD>
                                <span className='text-sm'>{new Date(x.timestamp*1000).toLocaleString()}</span>
                            </Table.TD>
                        </Table.BodyTR>
                    ))
                ) : (
                    <Table.BodyTR>
                        <Table.TD colspan={3}>Keine Logs verfügbar</Table.TD>
                    </Table.BodyTR>
                )}
            </Table.TBody>
        </Table.Skeleton>
    );
};

export default LogsList;